const conf = {
  apiBaseUrl: "https://api.cssupport.it/css/v1",
};
export default conf;
